import { render, staticRenderFns } from "./BuyHistory.vue?vue&type=template&id=70198409&scoped=true"
import script from "./BuyHistory.vue?vue&type=script&lang=js"
export * from "./BuyHistory.vue?vue&type=script&lang=js"
import style0 from "./BuyHistory.vue?vue&type=style&index=0&id=70198409&prod&lang=scss"
import style1 from "./BuyHistory.vue?vue&type=style&index=1&id=70198409&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70198409",
  null
  
)

export default component.exports